import React from 'react';
import { Container } from './styled';
const LolRecord = () => {
  return <Container>준비중인 기능입니다</Container>;
};

export default LolRecord;
